//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CalendarioTabela from './CalendarioTabela';
import CalendarioForm from './CalendarioForm';
import CalendarioToolbar from './CalendarioToolbar';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'Calendario',
  data() {
    return {
      dialogForm: false,
      idEvento: null,
    };
  },
  components: {
    CalendarioForm,
    CalendarioTabela,
    CalendarioToolbar,
  },
  computed: {
    ...generateComputed('Cal', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  methods: {
    edit(id) {
      this.idEvento = id;
      this.abrirForm();
    },
    buscar() {
      this.fecharForm();
      this.$refs.tabela.filtrar();
    },
    abrirForm() {
      this.dialogForm = true;
    },
    fecharForm() {
      this.idEvento = null;
      this.dialogForm = false;
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.$router.push({ name: 'inicio' });
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/calendario/Calendario.vue?vue&type=script&lang=js&